import {internalLinkToHref} from '@/modules/foundation/sanity/link/query';
import {PortableText} from '@/modules/foundation/sanity/portable-text';

import {
	NemndListAll,
	nemndListAllDescriptionPortableTextOverrides,
} from '../../components/nemnd-list-all';

import type {NemndListAllFragment} from './query';

type Props = {
	data: NemndListAllFragment;
	fullWidth?: boolean;
	anchorHeadings?: boolean;
	insideToc?: boolean;
};

export const NemndListAllContainer = ({data, fullWidth, anchorHeadings, insideToc}: Props) => {
	const {contentBlockOptions, heading, description, nemnds} = data;

	return (
		<NemndListAll
			heading={heading}
			description={
				description && description.length > 0 ? (
					<PortableText
						value={description}
						overrideClassNames={nemndListAllDescriptionPortableTextOverrides}
					/>
				) : null
			}
			nemnds={
				nemnds && nemnds.length > 0
					? nemnds.map((nemnd) => ({
							_id: nemnd._id,
							name: nemnd.name ?? '',
							href: nemnd.slug?.current
								? internalLinkToHref('nemnd', nemnd.slug.current)
								: '',
							description:
								nemnd.description && nemnd.description.length > 0 ? (
									<PortableText value={nemnd.description} />
								) : null,
							icon: nemnd.icon ?? undefined,
						}))
					: []
			}
			anchorHeadings={anchorHeadings}
			options={{
				fullWidth,
				...contentBlockOptions,
			}}
			insideToc={insideToc}
		/>
	);
};
